export default __webpack_public_path__ + "static/media/logo5.14947527.jpg";